import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { changePasswordSuccess } from './change-password.actions';
import { tap} from 'rxjs/operators';
import { AUTH_KEY } from '../../../../@aes/core/auth/auth.effects';
import { LocalStorageService } from '../../../../@aes/core';
import { SystemAuditService } from '../../../../@aes/core/system-audit/system-audit.service';
import { Router } from '@angular/router';
import { AesAuthService } from '../../services';
import { Store } from '@ngrx/store';
import { AclService } from '../../../../@aes/acl/acl.service';
import { AppStateService } from '../../../../@aes/core/app-state';


@Injectable()
export class ChangePasswordEffects {
    success = createEffect(
        () =>
            this._actions$.pipe(
                ofType(changePasswordSuccess),
                tap(() => {
                    // send Logout Audit request to server before call _aesAuthService.logout()
                    // while the access token is still valid
                  this._aesAuthService.logout().then(() => {
                    this._localStorageService.setItem(AUTH_KEY, {
                      isAuthenticated: false,
                    });
                    this._appStateService.clear();
                  });
                })
            ),
        {dispatch: false}
    );

    constructor(
        private _actions$: Actions,
        private _localStorageService: LocalStorageService,
        private _systemAuditService: SystemAuditService,
        private _router: Router,
        private _aesAuthService: AesAuthService,
        private _store: Store<any>,
        private _aclService: AclService,
        private _appStateService: AppStateService
    ) {
    }
}
